/**
 * https://github.com/nachomazzara/parse-multipart-data
 */

import { camelize } from '../utils/stringHelper';

type Part = {
	header: Record<string, any>,
	data: Buffer[] | {} | string
};

const enum STEPS {
	LOAD_BOUDARY,
	LOAD_HEADER,
	LOAD_CONTENT,
}

export function parseMultipart(multipartBodyBuffer: Buffer, boundary: string): Part[] {
	let lastline = '';
	let header: Record<string, any> = {};
	let state: STEPS = STEPS.LOAD_BOUDARY;
	let buffer: Buffer;
	let startIndex = 0;
	const allParts: Part[] = [];

	for (let i = 0; i < multipartBodyBuffer.length; i++) {
		const oneByte: number = multipartBodyBuffer[i];
		const prevByte: number | null = i > 0 ? multipartBodyBuffer[i - 1] : null;
		const newLineDetected: boolean = !!(oneByte === 0x0a && prevByte === 0x0d);
		const newLineChar: boolean = !!(oneByte === 0x0a || oneByte === 0x0d);

		if (!newLineChar) lastline += String.fromCharCode(oneByte);

		if (newLineDetected) {
			if (state === STEPS.LOAD_BOUDARY) {
				if (`--${boundary}` === lastline) {
					state = STEPS.LOAD_HEADER;
				} else if (lastline.length === 0) {
					state = STEPS.LOAD_CONTENT;
					startIndex = i;
				}
				lastline = '';
			} else if (state === STEPS.LOAD_HEADER) {
				if (lastline.length === 0) {
					state = STEPS.LOAD_CONTENT;
					startIndex = i;
				} else {
					const [key, val] = lastline.split(':');
					if (val) {
						const valParts = val.split(';').slice(1);
						if (valParts.length) {
							header = valParts.reduce((accumulator, currentValue) => {
								const [partKey, partVal] = currentValue.split('=');
								return { ...accumulator, [partKey.trim()]: partVal.trim() };
							}, header);
						}
						header[camelize(key.trim())] = val.trim();
					}
				}
				lastline = '';
			} else if (state === STEPS.LOAD_CONTENT) {
				const isEof = `--${boundary}--` === lastline;
				const isEop = `--${boundary}` === lastline; // endOfPart
				if (isEop || isEof) {
					const j = i - lastline.length;
					const slicedBuffer = multipartBodyBuffer.slice(startIndex, j - 1);
					const data: any = parseContent(header, slicedBuffer);
					allParts.push({ header, data });
					header = {};
					state = STEPS.LOAD_HEADER;
				}
				lastline = '';
			}
		}
	}
	return allParts;
}

export function getBoundary(header: string): string {
	const items = header.split(';');
	if (items) {
		for (let i = 0; i < items.length; i++) {
			const item = items[i].trim();
			if (item.indexOf('boundary') >= 0) {
				const k = item.split('=');
				return (k[1][0] === '"' && k[1][k[1].length - 1] === '"') ? k[1].slice(1, -1).trim() : k[1].trim();
			}
		}
	}
	return '';
}

function parseContent(header: Record<string, any>, contentBuffer: Buffer): number[] | {} | string {
	const contentType: string = header.contentType || '';
	if (contentType.includes('json')) {
		return JSON.parse(Buffer.from(contentBuffer).toString('utf8'));
	}
	return Buffer.from(contentBuffer);
}
